
import { CalculatorCategory } from '@/lib/types/calculator.types';

export const educationCategory: CalculatorCategory = {
  id: 'education',
  name: 'Math & Education',
  description: 'Educational calculators for math, science, and academic planning',
  theme: 'education',
  icon: 'calculator',
  calculators: [
    {
      id: 'graphing',
      name: 'Graphing Calculator',
      description: 'Advanced graphing calculator with function plotting and analysis',
      theme: 'education'
    },
    {
      id: 'scientific',
      name: 'Scientific Calculator',
      description: 'Advanced mathematical calculations',
      theme: 'education'
    },
    {
      id: 'matrix',
      name: 'Matrix Calculator',
      description: 'Matrix operations and calculations',
      theme: 'education'
    },
    {
      id: 'geometry',
      name: 'Geometry Calculator',
      description: 'Calculate areas, volumes, and geometric properties',
      theme: 'education'
    },
    {
      id: 'gpa',
      name: 'GPA Calculator',
      description: 'Calculate Grade Point Average',
      theme: 'education'
    },
    {
      id: 'grade',
      name: 'Grade Calculator',
      description: 'Calculate grades and percentages',
      theme: 'education'
    },
    {
      id: 'study-time',
      name: 'Study Time Optimizer',
      description: 'Optimize your study schedule',
      theme: 'education'
    },
    {
      id: 'academic-progress',
      name: 'Academic Progress Tracker',
      description: 'Track academic performance',
      theme: 'education'
    },
    {
      id: 'triangle',
      name: 'Triangle Calculator',
      description: 'Calculate triangle properties',
      theme: 'education'
    },
    {
      id: 'random-number',
      name: 'Random Number Generator',
      description: 'Generate random numbers',
      theme: 'education'
    },
    {
      id: 'probability',
      name: 'Probability Calculator',
      description: 'Calculate probabilities',
      theme: 'education'
    },
    {
      id: 'statistical-significance',
      name: 'Statistical Significance',
      description: 'Test statistical significance',
      theme: 'education'
    }
  ]
};

export default educationCategory;
